import VueRouter from 'vue-router'
import {  AxiosInstance} from 'axios'
import { CacheKey } from '@/constants'
import db, {firebaseApp} from "@/plugins/firebase";
import {store} from "@/store";

const authService = new class AuthService {

  async canNavigate(page: string | null | undefined, user: User): Promise<boolean> {
    return page? (user as any)[page] : false;
  }

  async setupRouter (router: VueRouter) {
    router.beforeEach(async (to, from, next) => {
      const user: any = { ...store.state.auth.user };
      if(user) {
        const authorized = to.meta.allowedRoles ? this.canNavigate(to.meta.authority,user): true;
        authorized ? next() : next("/unauthorized");
      } else {
        to.meta.allowedRoles ? next("/login") : next();
      }
      next();
    });
  }

  setupInterceptors (ax: AxiosInstance, router?: VueRouter) {
    ax.interceptors.request.use(async config => {
      config.headers.common['x-api-key'] = 'W1QPvME5Mfod1tTdSeUz1WkfHnAq6Oe9yrtKDDka';
      const token = localStorage.getItem(CacheKey.TOKEN);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    if (router) {
      ax.interceptors.response.use(res => res, err => {
        const status = err && (err.status || (err.response && err.response.status));
        if (status === 401) {
          sessionStorage.setItem(CacheKey.REQUESTED_URL, router.currentRoute.fullPath);

          router.push('/login');
        }
        throw err;
      });
    }
  }
}

export default authService;
